// src/hooks/useScrollDirection.ts
import { useState, useEffect, useRef } from 'react';

export function useScrollDirection(threshold = 10) {
  const [scrollMetrics, setScrollMetrics] = useState({
    dir: 'up' as 'up' | 'down',
    scrollY: 0,
  });

  const lastScrollY = useRef(0);
  const ticking = useRef(false);

  useEffect(() => {
    lastScrollY.current = window.scrollY;

    const updateScrollDir = () => {
      const currentScrollY = window.scrollY;
      const diff = currentScrollY - lastScrollY.current;

      // 只有當位移超過閾值時才更新方向
      if (Math.abs(diff) > threshold) {
        setScrollMetrics({
          dir: diff > 0 ? 'down' : 'up',
          scrollY: currentScrollY,
        });
        lastScrollY.current = currentScrollY;
      }
      ticking.current = false;
    };

    const onScroll = () => {
      if (!ticking.current) {
        window.requestAnimationFrame(updateScrollDir);
        ticking.current = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrollMetrics;
}
